// Fase D - PR #56
// Stepper visual de 4 pasos para el protocolo del auxiliar:
//   1. Saludo (QR escaneado)
//   2. Alergias (solo si es la 1a comida del dia del paciente)
//   3. Menu (elegir opcion + excluir)
//   4. Confirmar (enviar a cocina)
//
// Se usa arriba del AlergiaInicialModal y del OfertaMenu.

interface Props {
  pasoActual: 1 | 2 | 3 | 4
  // Si true, el paso 2 (alergias) se renderiza tachado/saltado porque
  // el paciente ya fue consultado hoy.
  alergiasSaltadas?: boolean
}

const PASOS = [
  { n: 1, label: 'Saludo', icon: '👋' },
  { n: 2, label: 'Alergias', icon: '⚠️' },
  { n: 3, label: 'Menú', icon: '🍽' },
  { n: 4, label: 'Confirmar', icon: '✓' },
] as const

export default function ProtocoloStepper({ pasoActual, alergiasSaltadas = false }: Props) {
  return (
    <div className="flex items-center justify-between mb-4 select-none">
      {PASOS.map((p, idx) => {
        const completado = p.n < pasoActual
        const activo = p.n === pasoActual
        const saltado = p.n === 2 && alergiasSaltadas
        return (
          <div key={p.n} className="flex items-center flex-1">
            <div className="flex flex-col items-center min-w-0">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition ${
                  saltado
                    ? 'border-gray-300 bg-gray-100 text-gray-400'
                    : completado
                      ? 'border-green-500 bg-green-500 text-white'
                      : activo
                        ? 'border-avante-primary bg-avante-primary text-white animate-pulse'
                        : 'border-gray-300 bg-white text-gray-400'
                }`}
              >
                {completado ? '✓' : saltado ? '—' : p.n}
              </div>
              <span
                className={`text-[10px] mt-1 truncate max-w-[60px] ${
                  saltado
                    ? 'text-gray-400 line-through'
                    : activo
                      ? 'font-bold text-avante-primary'
                      : completado
                        ? 'text-green-700'
                        : 'text-gray-500'
                }`}
              >
                {p.label}
              </span>
            </div>
            {idx < PASOS.length - 1 && (
              <div
                className={`flex-1 h-0.5 mx-1 -mt-4 ${
                  completado || (saltado && p.n === 2)
                    ? 'bg-green-500'
                    : 'bg-gray-300'
                }`}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
